<template>
  <div>
    <nba-scoring :scoring="scoring" :Position="Profile" v-if="sportId == 1" />
    <mlb-scoring :scoring="scoring" :Position="Profile" v-if="sportId == 2" />
    <nhl-scoring :scoring="scoring" :Position="Profile" v-if="sportId == 3" />
    <nfl-scoring :scoring="scoring" :Position="Profile" v-if="sportId == 4" />
  </div>
</template>

<script>
import MlbScoring from "./playerScoring/MlbScoring.vue";
import NbaScoring from "./playerScoring/NbaScoring.vue";
import NflScoring from "./playerScoring/NflScoring.vue";
import NhlScoring from "./playerScoring/NhlScoring.vue";

export default {
  components: { NbaScoring, MlbScoring, NhlScoring, NflScoring },
  name: "scoring",
  props: {
    scoring: {
      type: [Array, Object],
      default: () => [],
    },
    Profile: {
      type: Object,
      default: () => {},
    },
    sportId: {
      type: [String, Number],
      default: "",
    },
  },
};
</script>

<style scoped></style>
